<template>
    <v-menu offset-y open-on-hover :close-on-content-click="false" :open-delay="150">
        <template v-slot:activator="{ on }">
            <v-btn :color="color" dark v-on="on" @mouseover="onOpen"
                   :to="{name: 'CustomerShow', params: {id: customerId}}" class="customer-info-button">
                <span v-if="isCompany !== null">
                    <strong class="purple--text text--lighten-4" v-if="isCompany">B</strong>
                    <strong class="green--text text--lighten-4" v-else>P</strong>
                </span>
                <span :class="isCompany !== null ? 'ml-3' : null">{{ label }}</span>
            </v-btn>
        </template>
        <v-card v-if="loading">
            <v-card-text>
                <v-progress-linear indeterminate/>
            </v-card-text>
        </v-card>
        <customer-card style="max-width: 400px" :customer="customer" v-else/>
    </v-menu>
</template>

<script>
import CustomerCard from './CustomerCard';

export default {
    components: {
        CustomerCard
    },

    props: {
        label: String,
        customerId: Number,
        isCompany: {
            type: Boolean,
            default: null
        }
    },

    data() {
        return {
            loading: true,
            customer: null
        }
    },

    methods: {
        onOpen() {
            if (this.customer) return;

            this.$http.get(`customers/${this.customerId}`).then(response => {
                this.customer = response.data.data;
            }).finally(() => this.loading = false);
        }
    },

    computed: {
        color() {
            if (this.isCompany === null) return 'blue-grey';
            return this.isCompany ? 'purple' : 'green';
        }
    },
}
</script>

<style>
.customer-info-button span {
    max-width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
